export default "__VITE_ASSET__ht4AjAdM__"